import { ReactNode, useMemo } from 'react';
import { NotificationContext } from './NotificationContext';
import { SnackbarProvider } from './SnackbarContext';
import { useSnackbarNotificationService } from './SnackbarNotificationService';

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({
  children,
}: Readonly<NotificationProviderProps>) {
  return (
    <SnackbarProvider>
      <NotificationProviderInner>{children}</NotificationProviderInner>
    </SnackbarProvider>
  );
}

/**
 * Inner provider that has access to the Snackbar context
 */
function NotificationProviderInner({
  children,
}: Readonly<NotificationProviderProps>) {
  const service = useSnackbarNotificationService();
  const contextValue = useMemo(
    () => ({ notificationService: service }),
    [service],
  );

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
}
